import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-profile-latest-deactivated-accounts',
  templateUrl: './profile-latest-deactivated-accounts.component.html',
  styleUrls: ['./profile-latest-deactivated-accounts.component.scss']
})
export class ProfileLatestDeactivatedAccountsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
